export default __webpack_public_path__ + "static/media/emp.b5733551.svg";